(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire93c1"];
var parcelRegister = parcelRequire.register;
parcelRegister("gDnyr", function(module, exports) {

$parcel$export(module.exports, "animatedGridHandler", function () { return $c1c28f515151cf2d$export$4f3dd6b46d78b84c; });
/**
 * Handles grid element scaling in animated grids
 * @param {Object} element - Block
 */ const $c1c28f515151cf2d$export$4f3dd6b46d78b84c = (element)=>{
    const boxes = element.querySelectorAll(".grid-elem");
    boxes.forEach((box)=>{
        box.addEventListener("mouseenter", (e)=>{
            // Change: Get top of target (Mouse hover)
            const targetRect = e.target.getBoundingClientRect();
            boxes.forEach((bBox)=>{
                // Change: Get top of other elements
                const bBoxRect = bBox.getBoundingClientRect();
                if (!e.target.classList.contains("grid-elem--animated")) e.target.classList.add("grid-elem--animated");
                // Change: Add class if not assigned
                if (!e.target.classList.contains("grid-elem--animated-height")) e.target.classList.add("grid-elem--animated-height");
                if (bBox != e.target) {
                    bBox.classList.remove("grid-elem--animated");
                    // Change: If / else detects if the box has the same top as the target  
                    if (targetRect.top === bBoxRect.top) // Change: Add class if not assigned
                    {
                        if (!bBox.classList.contains("grid-elem--animated-height")) bBox.classList.add("grid-elem--animated-height");
                    } else // Change: Remove class if tops are different
                    bBox.classList.remove("grid-elem--animated-height");
                }
            });
        });
    });
};

});

})();
//# sourceMappingURL=animated-grid.4472c587.js.map
